import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "services" }
const _hoisted_2 = { class: "features" }
const _hoisted_3 = { class: "feature-wrapper" }
const _hoisted_4 = { class: "feature-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "popup-box" }
const _hoisted_7 = { class: "popup-list" }

import {ref} from "vue";
import {Aperture, Car, CheckCircle, Paintbrush, Plus, Shield, ShoppingBag, Truck, Wrench, Zap,} from "lucide-vue-next";

import '@/assets/styles/service.css';

interface Service {
  title: string;
  services: string[];
  icon: any; // Icon Component
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const selected = ref<Service | null>(null);

const services: Service[] = [
  {
    title: "Wartung & Reparatur",
    icon: Wrench,
    services: [
      "Inspektionen nach Herstellervorgaben (inkl. Serviceheftpflege / digitaler Serviceeintrag)",
      "Ölwechsel & Flüssigkeitsservice (Motoröl, Bremsflüssigkeit, Kühlmittel, Servolenkung)",
      "Bremsenservice (Bremsbeläge, Bremsscheiben, Bremsprüfung)",
      "Motor- und Getriebereparaturen (inkl. Fehlerdiagnose und Instandsetzung)",
      "Getriebeölspülung (für Automatikgetriebe zur Lebensdauerverlängerung)",
      "Auspuff- und Fahrwerksarbeiten (Stoßdämpfer, Federn, Querlenker etc.)",
      "Elektronik- & Diagnoseservice (Fehlerspeicher auslesen, Steuergeräte-Diagnose)",
    ],
  },
  {
    title: "Ergänzende Leistungen",
    icon: Plus,
    services: [
      "Windschutzscheiben-Reparatur & Austausch",
      "Batterieservice (Prüfung, Austausch, Start-/Stopp-Batterien)",
      "Klimaanlagenservice (Wartung, Desinfektion, Kältemittel-Service)",
      "Zahnriemen- & Kettenservice",
    ],
  },
  {
    title: "Fahrzeugverkauf & Beratung",
    icon: Car,
    services: [
      "Verkauf von Gebrauchtwagen",
      "Inzahlungnahme von Altfahrzeugen",
    ],
  },
  {
    title: "Karosserie & Lack",
    icon: Paintbrush,
    services: [
      "Unfallreparaturen",
      "Lackierungen und Smart Repair",
      "Rostschutz und Versiegelung",
    ],
  },
  {
    title: "Reifenservice",
    icon: Aperture,
    services: [
      "Reifenwechsel (Sommer-/Winterreifen)",
      "Einlagerung von Reifen",
      "Auswuchten der Räder",
      "Reifenreparatur",
      "Montage von Reifen auf Felgen",
      "RDKS-Service",
      "Reifenprüfung & Beratung",
    ],
  },
  {
    title: "Prüfungen & Zulassung",
    icon: CheckCircle,
    services: [
      "Hauptuntersuchung (HU) & Abgasuntersuchung (AU)",
      "Fahrzeugzulassung und Abmeldung",
      "Sicherheitschecks",
    ],
  },
  {
    title: "Firmenfahrzeuge",
    icon: Shield,
    services: [
      "UVV-Prüfung nach DGUV Vorschrift 70",
      "Dokumentation und Prüfprotokolle",
    ],
  },
  {
    title: "Spezielle Dienstleistungen",
    icon: Zap,
    services: [
      "Klimaanlagenservice",
      "Nachrüstung von Zubehör (z. B. Anhängerkupplung, Navi)",
    ],
  },
  {
    title: "Zusatzservices",
    icon: Truck,
    services: [
      "Ersatzwagen / Mietwagen",
      "Hol- und Bringservice",
    ],
  },
  {
    title: "Ersatzteile & Zubehör",
    icon: ShoppingBag,
    services: [
      "Original- und Ersatzteile",
      "Verschleißteile (Bremsen, Filter, Batterien)",
      "Zubehör (Fußmatten, Dachträger, Pflegeprodukte)",
      "Nachrüstungen",
      "Beratung zu passenden Teilen",
    ],
  },
  /*{
    name: "Wartungsarbeiten & Reparaturen",
    details:
        "Inspektionen nach Herstellervorgaben (inkl. Serviceheftpflege / digitaler Serviceeintrag), Ölwechsel & Flüssigkeitsservice (Motoröl, Bremsflüssigkeit, Kühlmittel, Servolenkung), Bremsenservice (Bremsbeläge, Bremsscheiben, Bremsprüfung), Motor- und Getriebereparaturen (inkl. Fehlerdiagnose und Instandsetzung), Getriebeölspülung (für Automatikgetriebe zur Verlängerung der Lebensdauer und Verbesserung des Schaltverhaltens), Auspuff- und Fahrwerksarbeiten (Stoßdämpfer, Federn, Querlenker etc.), Elektronik- & Diagnoseservice (Fehlerspeicher auslesen, Steuergeräte-Diagnose)",
    icon: Wrench,
  },
  {
    name: "Fahrzeugdiagnose",
    details: "Fehlerspeicher auslesen, Software-Updates, Überprüfung von Motor- und Sicherheitssystemen",
    icon: NotebookText,
  },
  {
    name: "Glasschäden",
    details: "Steinschlagreparatur, Scheibenaustausch bei Schäden",
    icon: Framer,
  },
  {
    name: "HU / AU (TÜV)",
    details: "Vorbereitung und Durchführung der gesetzlich vorgeschriebenen Prüfungen",
    icon: CheckCircle,
  },
  {
    name: "Ersatzteile & Zubehör",
    details: "Originalteile und Zubehör für Ihr Fahrzeug, Fairer und zuverlässiger Verkauf",
    icon: ShoppingBag,
  },
  {
    name: "Gebrauchtwagen Ankauf & Verkauf",
    details: "Kauf von Gebrauchtwagen Verkauf von Gebrauchtwagen",
    icon: Car,
  },
  {
    name: "Zusatzleistungen",
    details: "HU/AU Vorbereitung, Fahrzeugaufbereitung / PflegeAchsvermessung",
    icon: Layers,
  },*/
];

const showPopup = (service: Service) => {
  selected.value = service;
};

const closePopup = () => {
  selected.value = null;
};

// Hilfsfunktion für Liste im Template
const detailsList = (details: string) =>
    details.split(",").map(d => d.trim()).filter(d => d.length > 0);


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Dienstleistungen", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service) => {
              return _createElementVNode("div", {
                class: "feature-card",
                key: service.title,
                onClick: ($event: any) => (showPopup(service))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon), { class: "feature-icon" })),
                _createElementVNode("h3", null, _toDisplayString(service.title), 1)
              ], 8, _hoisted_5)
            }), 64))
          ])
        ])
      ]),
      (selected.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "popup-overlay",
            onClick: _withModifiers(closePopup, ["self"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "close-btn-service",
                type: "button",
                "aria-label": "Popup schliessen",
                onClick: closePopup
              }, "x"),
              (_openBlock(), _createBlock(_resolveDynamicComponent(selected.value.icon), { class: "popup-icon" })),
              _createElementVNode("h2", null, _toDisplayString(selected.value.title), 1),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selected.value.services, (detail) => {
                  return (_openBlock(), _createElementBlock("li", { key: detail }, _toDisplayString(detail), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})